import { fetchAllLanguages } from 'app-redux/actions/languages.actions';
import { AppState } from 'app-redux/reducers';
import { LanguageModel } from 'core/languages/languages.model';
import React, { useEffect, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { connect } from 'react-redux';
import { Select } from 'syngenta-digital-cropwise-react-ui-kit';
const {
  Option
} = Select;
interface IAvailableLanguagesDropdownProps {
  preSelectedLanguageKey: string;
  onClick: (languageKey: string) => void;
  languages: LanguageModel[];
  fetchAllLanguages: () => Promise<LanguageModel[]>;
}
const AvailableLanguagesDropdownComponent = ({
  fetchAllLanguages,
  languages,
  onClick,
  preSelectedLanguageKey
}: IAvailableLanguagesDropdownProps) => {
  const {
    t
  } = useTranslation();
  useEffect(() => {
    fetchAllLanguages();
  }, [fetchAllLanguages]);
  const availableLanguages = useMemo(() => languages.map(language => ({
    key: language.key,
    variations: language.variations,
    label: t(language.key)
  })), [languages, t]);
  const selectedLanguageLabel = useMemo(() => {
    const language = availableLanguages.find(language => language.variations.includes(preSelectedLanguageKey) || language.key === preSelectedLanguageKey);
    return language?.label;
  }, [availableLanguages, preSelectedLanguageKey]);
  return <Select showSearch={true} value={selectedLanguageLabel} onChange={languageKey => onClick(languageKey)} style={{
    width: '180px'
  }} filterOption={(input, option) => {
    const optionLabel: string = (option?.label as string)?.toLowerCase() ?? '';
    const key = (option?.key as string);
    const optionKey = key.toLowerCase();
    const normalizedInput = input.toLowerCase();
    return optionLabel.includes(normalizedInput) || optionKey.includes(normalizedInput);
  }} data-sentry-element="Select" data-sentry-component="AvailableLanguagesDropdownComponent" data-sentry-source-file="index.tsx">
      {availableLanguages.map(lan => <Option key={lan.key} value={lan.key} label={lan.label}>
          {lan.label}
        </Option>)}
    </Select>;
};
const mapStateToProps = (state: AppState) => ({
  languages: state.languages.languages
});
const mapDispatchToProps = (dispatch: any) => ({
  fetchAllLanguages: () => dispatch(fetchAllLanguages())
});
export const AvailableLanguagesDropdown = connect(mapStateToProps, mapDispatchToProps)(AvailableLanguagesDropdownComponent);